export default __webpack_public_path__ + "img/Montserrat-Black_a99d8db.woff";